// How a plugin's declared commands map to palette slash commands. Each plugin
// gets a short prefix (its manifest `commandPrefix`, else the last dot-segment of
// its id), and each command becomes `/<prefix>:<short>` where <short> is the last
// dot-segment of the command id (e.g. prefix 'wc' + 'wordcount.count' -> /wc:count).
// A single-command plugin also answers to the bare `/<prefix>` (e.g. /wc).

import type { PluginManifest } from '@slate/plugin-api';

function lastSegment(dotted: string): string {
  const seg = dotted.slice(dotted.lastIndexOf('.') + 1);
  return seg || dotted;
}

/** The slash prefix for a plugin's commands. */
export function pluginSlashPrefix(manifest: PluginManifest): string {
  const declared = manifest.commandPrefix?.trim();
  if (declared) return declared;
  return lastSegment(manifest.id);
}

/** The slash form of one command, e.g. '/wc:count'. */
export function commandSlash(manifest: PluginManifest, commandId: string): string {
  return `/${pluginSlashPrefix(manifest)}:${lastSegment(commandId)}`;
}

/** The bare slash for a single-command plugin, e.g. '/wc'. */
export function bareSlash(manifest: PluginManifest): string {
  return `/${pluginSlashPrefix(manifest)}`;
}
